import type { FaireProductEntity } from "../../entity_types/product";

export const p_sbfm4jdgd4: FaireProductEntity = {
  token: "p_sbfm4jdgd4",
  type: "product",
  name: "KD-TP1000 Kids Print Baby Doll Top - Leopard",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/7282b308481328b4c7c047179112024de120d9697d3bd30f5546026247a57666.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description: "This playful kids' top features a lively leopard print designed to add fun and flair to a child's wardrobe. Girlie Girl Originals offers a bold, trendy choice that complements youthful styles with a southern-inspired attitude.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:51.992Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
